// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","main-color":"var(--main-color)","grey-xlight":"#fcfcfc","container":"_3f0A08K _1ZWPIqK","application_content":"_32oE_vl","controls":"WCk4qU_"};